var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-with-sidebar',[_c('HeaderComponent'),_c('div',{staticClass:" ed-bg text-color",staticStyle:{"min-height":"100vh","overflow-x":"scroll"}},[_c('div',{staticClass:"container-fluid"},[_c('TableShort')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }